
import { BaseModel } from "./../../models/base-model";
import { AuthTransfer, AuthVerified } from "../../models/generic/auth-transfer";

export interface IAuthorizationResponse {
    Status?: AuthorizationResponseStatus;
    webAppVersion?: string;
    webAppEndPoint?: string;
    webApiVersion?: string;
    webApiEndPoint?: string;
    authApiEndPoint?: string;
    environment?: string;
    languageCode?: string;
    originDomain?: string;
    oauth2?: IOauthorization2Info;
    data?: Oauth2Data;
}

export class Oauth2Data {
    information?: Oauth2DataInformation;
    oauth2?: IOauthorization2Info;
}

export class Oauth2DataInformation {
    webAppVersion?: string;
    webAppEndPoint?: string;
    webApiVersion?: string;
    webApiEndPoint?: string;
    authApiEndPoint?: string;
    languageCode?: string;
    originDomain?: string;
    sessionId?: string;
    customerName?: string;
}

export enum AuthorizationResponseStatus {
    Success = 0,
    Failure,
    RequestToken,
    Redirect
}

export interface IOauthorization2Info {
    identityToken?: string;
    accessToken?: string;
    refreshToken?: string;
    authenticationTime?: Date;
    accessTokenExpiration?: Date;
}
export class Oauthorization2Response extends BaseModel<IAuthorizationResponse>
    implements IAuthorizationResponse {
    Status?: AuthorizationResponseStatus;
    webAppVersion?: string;
    webAppEndPoint?: string;
    webApiVersion?: string;
    webApiEndPoint?: string;
    authApiEndPoint?: string;
    environment?: string;
    languageCode?: string;
    originDomain?: string;
    oauth2?: IOauthorization2Info;
    data?: Oauth2Data;
    constructor(option?: Oauthorization2Response) {
        super(option);
    }
}

export interface IAuthorizationResponse {
    //Status?: AuthorizationResponseStatus;
}

export class AuthorizationResponse extends BaseModel<IAuthorizationResponse>
    implements IAuthorizationResponse {
    Status?: AuthorizationResponseStatus;
    Token?: string;
    Config?: AuthTransfer;
    UserInfo?: AuthVerified;
    CurrentRequestUrl?: string;
    CurrentLanguage?: string;
    constructor(option?: IAuthorizationResponse) {
        super(option);
    }
}

